export class BaseModel {
  id: string
  is_enabled: boolean
  title: string
  description: string

  constructor(obj: any = null) {
    this.id = obj?.id || obj?._id || null
    this.is_enabled = obj?.is_enabled || false
    this.title = obj?.title
    this.description = obj?.description
  }
}

export interface BaseOptionsListModel {
  id: string | number | boolean
  title: string
  urlNavigation?: string
  imageUlr?: string
  icon?: string
}


export type SizeElements = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

